import {
  useQuery,
  ExtractFnReturnType,
  QueryConfigType,
  UseQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import { ApiMembersAiGeneratedEmployeeChallengeShowResponseType } from "../../types";

const request =
  async (): Promise<ApiMembersAiGeneratedEmployeeChallengeShowResponseType> => {
    const response =
      await new ApiClient().get<ApiMembersAiGeneratedEmployeeChallengeShowResponseType>(
        "/api/members/ai_generated_employee_challenge",
      );
    return response.data;
  };

type QueryFnType = typeof request;

type PropsType = {
  config?: QueryConfigType<QueryFnType>;
};

export const useApisMembersAiGeneratedEmployeeChallengeShow = ({
  config = {},
}: PropsType = {}): UseQueryResult<ApiMembersAiGeneratedEmployeeChallengeShowResponseType> => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ["ApisMembersAiGeneratedEmployeeChallengeShow"],
    queryFn: () => request(),
  });
};
